import React from "react";
import styled from "@emotion/styled";
import MobileCategories from "@components/MobileCategories";
import BuyPageBrands from "@components/BuyPageBrands";
import { NewBrands } from "@components/NewBuyPageComponents";
import Resizer from "@hocs/Resizer";
import { ClearedStyleRouterLink } from "@modules/Components";
import {
  CHANGE_BUY_SEARCH_TEXT,
  SET_CATEGORY,
  SHOW_ALL_MERCHANTS
} from "@constants/actionTypes";
import { defaultAction } from "@actions/defaultAction";
import { useDispatch } from "react-redux";

const LargeScreenView = styled.div`
  @media (max-width: 767px) {
    display: none;
  }
`;

const MobileCategorySearch = styled.div`
  @media (min-width: 768px) {
    display: none;
  }
`;

const BacktoAllCards = styled(ClearedStyleRouterLink)`
  font-size: 15px;
  font-weight: bold;
  color: #ff9c1b !important;
`;

const BuyPageCardsHeader = ({
  categoryName = undefined,
  page,
  newGifting = false
}) => {
  const dispatch = useDispatch();

  return (
    <Resizer
      components={[
        {
          component: () => (
            <MobileCategorySearch>
              <MobileCategories
                categoryName={categoryName}
                newGifting={newGifting}
              />
            </MobileCategorySearch>
          ),
          break: 1,
          maxBreak: 768
        },
        {
          component: () => (
            <LargeScreenView>
              {page === "buy" ? (
                <BuyPageBrands />
              ) : page === "newBuy" ? (
                <NewBrands />
              ) : page === "buyCategories" ? (
                <BacktoAllCards
                  to="/buy-gift-cards/"
                  onClick={() => {
                    dispatch(defaultAction(SHOW_ALL_MERCHANTS));
                    dispatch(defaultAction(SET_CATEGORY, ""));
                    dispatch(defaultAction(CHANGE_BUY_SEARCH_TEXT, ""));
                  }}
                >
                  Back to All Cards
                </BacktoAllCards>
              ) : page === "newBuyCategories" ? (
                <BacktoAllCards
                  to="/buy-gift-cards/new/"
                  onClick={() => {
                    dispatch(defaultAction(SET_CATEGORY, ""));

                    dispatch(defaultAction(CHANGE_BUY_SEARCH_TEXT, ""));
                  }}
                >
                  Back to All Cards
                </BacktoAllCards>
              ) : (
                <></>
              )}
            </LargeScreenView>
          ),
          break: 767,
          maxBreak: Number.MAX_SAFE_INTEGER
        }
      ]}
    />
  );
};

export default BuyPageCardsHeader;
